import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const countriesService = new CachedService(entities.Orderadmin_Locations_Entity_Country, '/locations/countries', HALApiService, createItemsData)
